import '../styles/index.scss';

import './_swiper';
import './_menu';
import './_contact';

document.querySelector('#currentYear').textContent = new Date().getFullYear();
